export const SALES_CHANNEL = {
  NA: 0,
  OFFLINE: 1,
  ONLINE: 2
}
